import React from 'react';
import { Container } from 'react-bootstrap';
import { APP_VERSION, BUILD_DATE, VERSION_DESCRIPTION } from '../version';

const Footer: React.FC = () => {
  const formatBuildDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat('it-IT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  };

  return (
    <footer className="sticky-footer">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="text-muted">
            <i className="bi bi-airplane"></i> Price Tracker
          </div>
          <div className="text-muted d-flex align-items-center gap-3">
            <span title={VERSION_DESCRIPTION}>
              <i className="bi bi-code-square me-1"></i>
              v{APP_VERSION}
            </span>
            <span className="d-none d-md-inline" title="Build Date">
              <i className="bi bi-calendar3 me-1"></i>
              {formatBuildDate(BUILD_DATE)}
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
